<ng-content></ng-content>

<div class="mt-6 py-3 flex justify-end">
  @if (userApi.api.registrationUrl) {
    <Button href="{{ userApi.api.registrationUrl }}" target="_blank" color="gray" size="small" [outline]="true"
            [shadow]="false"
            class="mr-3">{{ 'INCLUDE_MODALUSERAPI_BUTTON_CREATE_ACCOUNT' | translate: {apiName: userApi.api.name} }}
    </Button>
  }
  @if (configured()) {
    <Button (click)="letsDoOAuth()" color="blue" size="small" type="button">{{ 'BUTTON_TEST_AND_SAVE' | translate }}
    </Button>
  }
</div>
